<mat-card>
  <mat-card-content>
    <p>Följande dokument har skickats till Sparbanken Syd</p>
    @for (document of documentService.movedDocuments(); track document.id) {
      <spb-selected
        [removable]="false"
        color="#E0E0E0"
        [document]="document"></spb-selected>
    }
  </mat-card-content>
  <mat-card-actions align="end">
    <spb-try-again buttonText="Klar"></spb-try-again>
  </mat-card-actions>
</mat-card>

